module.exports = __webpack_public_path__ + "static/media/view.c9eb1974.svg";